import React, { useState } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Paper,
  TableContainer,
} from "@mui/material";
import NocMemoChallan from "./NocMemoChallan";

const NocPaymentTable = ({ nocPaymentDetails, formData }) => {
  const [showDetails, setShowDetails] = useState(false);

  if (!nocPaymentDetails) return null;

  const { challanNo, holderName, bankName, ifscCode } = nocPaymentDetails;

  return (
    <TableContainer component={Paper} sx={{ width: "100%", overflowX: "auto" }}>
      <Table sx={{ minWidth: 700 }} aria-label="noc payment table">
        <TableHead sx={{ backgroundColor: "rgba(52, 73, 94, 0.94)" }}>
          <TableRow>
            <TableCell sx={{ color: "#fff" }}>
              <b>Print Memo</b>
            </TableCell>
            <TableCell sx={{ color: "#fff" }}>
              <b>Challan No.</b>
            </TableCell>
            <TableCell sx={{ color: "#fff" }}>
              <b>Holder Name</b>
            </TableCell>
            <TableCell sx={{ color: "#fff" }}>
              <b>Bank Name</b>
            </TableCell>
            <TableCell sx={{ color: "#fff" }}>
              <b>IFSC Code</b>
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          <TableRow>
            {/* Popup cell */}
            <TableCell>
              <IconButton>
                <NocMemoChallan
                  nocPaymentDetails={nocPaymentDetails}
                />
              </IconButton>
            </TableCell>

            <TableCell>{challanNo || "N/A"}</TableCell>
            <TableCell>{holderName || "N/A"}</TableCell>
            <TableCell>{bankName || "N/A"}</TableCell>
            <TableCell>{ifscCode || "N/A"}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default NocPaymentTable;
